module.exports = __webpack_public_path__ + "static/media/accessibility.7fb1a328.svg";